import { Heart } from "lucide-react";
import { Reveal } from "./Reveal";
import { VALUES } from "@/lib/content";

export const Values = () => (
  <section data-testid="values-section" className="py-24 sm:py-36 bg-[#2D2A26] text-[#FBFBF8]">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14">
      <div className="lg:col-span-5 lg:sticky lg:top-28 self-start">
        <Reveal><p className="text-xs uppercase tracking-[0.3em] text-[#E3A57F] font-semibold">Our mission</p></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
            To guide people closer and closer to the God within, and remember they are <em className="text-[#E3A57F]">already worthy</em> of all good things.
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <div data-testid="law-of-love" className="mt-10 flex items-center gap-4 rounded-full border border-[#E3A57F]/50 px-6 py-4 w-fit">
            <Heart size={18} className="text-[#E3A57F]" />
            <span className="text-sm sm:text-base tracking-wide">This practice honors the law of love.</span>
          </div>
        </Reveal>
      </div>
      <ol className="lg:col-span-6 lg:col-start-7">
        {VALUES.map((v, i) => (
          <Reveal key={v.name} delay={i * 0.04} as="li" className="group grid grid-cols-[56px_1fr] gap-4 py-7 border-b border-white/15">
            <span className="font-display text-xl text-[#E3A57F]">0{i + 1}</span>
            <div>
              <h3 className="font-display text-3xl transition-transform duration-500 group-hover:translate-x-2">{v.name}</h3>
              <p className="mt-2 text-sm sm:text-base text-[#CFC8BC] leading-relaxed">{v.text}</p>
            </div>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
